import BaseModelAPI from '../BaseModelAPI';

export default class BillOfProcessList extends BaseModelAPI {

	static entity = 'billofprocesslist'
	static entityName = 'billofprocess';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
